<template>
  <HeaderTitle>
    <template #top>{{ t("header.my") }}</template>
    <template #bottom>{{ t("phileo") }}</template>
  </HeaderTitle>
  <div class="flex flex-col w-full">
    <div class="max-w-2xl mx-auto mb-8">
      <div class="text-left whitespace-pre-line">
        {{ t("overview.screen.web.body") }}
      </div>
    </div>

    <div class="flex flex-row justify-center items-center mt-4 gap-4">
      <BaseButton variant="outline" @click="$emit('redirectToLogin')">{{
        t("overview.screen.login.button.label")
      }}</BaseButton>
      <BaseButton variant="primary" @click="$emit('change-view', 'code')">{{
        t("registration.button.text")
      }}</BaseButton>
    </div>
  </div>
</template>
<script setup lang="ts">
import BaseButton from "../layout/button/BaseButton.vue";
import { useI18n } from "vue-i18n";
import HeaderTitle from "../layout/header/HeaderTitle.vue";

const { t } = useI18n();

defineEmits(["redirectToLogin", "change-view"]);
</script>
